import React from "react";
import "./Footer.scss";

export default function FooterComponent() {
  return (
    <div className="footer-component">© WAAW Blog 2022 by Grace Itiung </div>
  );
}
